// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App'
import 'ant-design-vue/dist/antd.css';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import {
	request
} from "../utils/request"
import api from "../utils/api"

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'




Vue.config.productionTip = false
Vue.use(Antd, VueAxios, axios);

Vue.prototype.$request = request;
Vue.prototype.$api = api;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})
// new Vue({
//   router,
//   render: h => h(App),
//   components: {
//     App
//   },
//   mounted () {
//     document.dispatchEvent(new Event('render-event'))
//   }
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js